// import React from "react";
import HealthOneBanner from "../../healthOneComponents/HealthOneBanner";
import HealthOneCounter from "../../healthOneComponents/HealthOneCounter";
import HealthOneServices from "../../healthOneComponents/HealthOneServices";
import HealthOneFeatures from "../../healthOneComponents/HealthOneFeatures";
import HealthOneTestimonial from "../../healthOneComponents/HealthOneTestimonial";
import HealthOneFaq from "../../healthOneComponents/HealthOneFaq";
import Post from "../../healthOneComponents/Post";
import HealthOnePricingPlans from "../../healthOneComponents/HealthOnePricingPlans";
import HealthOneNewera from "../../healthOneComponents/HealthOneNewera";
import HealthOneFooter from "../../healthOneComponents/HealthOneFooter";

const HealthOneHome = () => {
  return (
    <div>
      <HealthOneBanner></HealthOneBanner>
      <HealthOneCounter />
      <HealthOneServices />
      <HealthOneFeatures />
      <HealthOneTestimonial />
      <HealthOneFaq />
      <Post/>
      <HealthOnePricingPlans />
      <HealthOneNewera />
      <HealthOneFooter />
    </div>
  );
};

export default HealthOneHome;
